import DashboardLayout from "../components/layout";
import Customers from "../pages/customers";
import CustomerDetails from "../pages/customers/details";
import Dashboard from "../pages/dashboard/Index";
import Inventory from "../pages/inventory";
import Orders from "../pages/orders";
import Users from "../pages/users";
import AuthGuard from "../utilz/route-guard/auth-guard";
import Suppliers from "../pages/suppliers";
import ProductDetails from "../pages/inventory/details";
import SupplierDetails from "../pages/suppliers/details";
import DiscountDetails from "../pages/promo/details";
import Promotions from "../pages/promo";
import OrderDetails from "../pages/orders/details";
import PurchaseOrder from "../pages/purchase-order";
import Requisition from "../pages/requisition";
import Regions from "../pages/regions";
import RegionDetails from "../pages/regions/details";
import Notifications from "../pages/notifications";
import Settings from "../pages/Settings";
import RequisitionDetails from "../pages/requisition/details";
import PurchaseDetails from "../pages/purchase-order/details";
import Transactions from "../pages/transactions";
import TransactionsDetails from "../pages/transactions/details";
import LandingPage from "../pages/landing";
import { Navigate } from "react-router-dom";

interface RouteConfig {
  path: string;
  title?: string;
}

export interface RouteConfigMap {
  dashboard: RouteConfig;
  orders: RouteConfig;
  inventory: RouteConfig;
  users: RouteConfig;
  customers: RouteConfig;
  suppliers: RouteConfig;
  discount: RouteConfig;
  notifications: RouteConfig;
  settings: RouteConfig;
  withdrawalDetails: RouteConfig;
  requisition: RouteConfig;
  regions: RouteConfig;
  [key: string]: RouteConfig;
}

export const routeConfig: RouteConfigMap = {
  dashboard: {
    path: "dashboard",
    title: "Overview",
  },
  orders: {
    path: "orders",
    title: "Orders",
  },
  inventory: {
    path: "inventory",
    title: "inventory",
  },
  users: {
    path: "users",
    title: "Users",
  },
  customers: {
    path: "customers",
    title: "Customers",
  },
  regions: {
    path: "regions",
    title: "Sourcing Regions",
  },
  suppliers: {
    path: "suppliers",
    title: "Suppliers",
  },
  settings: {
    path: "settings",
    title: "Settings",
  },
  notifications: {
    path: "notifications",
    title: "Notifications",
  },
  purchase: {
    path: "purchase-orders",
    title: "Purchase Order",
  },
  discount: {
    path: "discount",
    title: "Discount",
  },
  transactions: {
    path: "transactions",
    title: "Transactions",
  },
  requisition: {
    path: "requisition",
    title: "Requisition",
  },
  analytics: {
    path: "analytics",
    title: "Analytics",
  },
  withdrawalDetails: {
    path: "withdrawal/details/:id",
  },
};

// =======|| MAIN ROUTING ||========= //
const MainRoutes = [
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
  },

  {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      // Dashboard root
      { path: "/dashboard", element: <Dashboard /> },
      { index: true, element: <Dashboard /> }, // This handles the /dashboard index route

      {
        path: routeConfig.orders.path,
        element: <Orders />,
      },
      {
        path: routeConfig.inventory.path,
        element: <Inventory />,
      },
      {
        path: routeConfig.users.path,
        element: <Users />,
      },
      {
        path: routeConfig.customers.path,
        element: <Customers />,
      },

      { path: "customers/:id", element: <CustomerDetails /> },
      { path: "inventory/:id", element: <ProductDetails /> },
      { path: "supplier/:id", element: <SupplierDetails /> },
      { path: "discount/:id", element: <DiscountDetails /> },
      { path: "order/:id", element: <OrderDetails /> },
      { path: "purchase/:id", element: <PurchaseDetails /> },
      { path: "regions/:id", element: <RegionDetails /> },
      { path: "requisition/:id", element: <RequisitionDetails /> },
      { path: "orders/:id", element: <OrderDetails /> },
      { path: "transactions/:id", element: <TransactionsDetails /> },

      {
        path: routeConfig.discount.path,
        element: <Promotions />,
      },
      {
        path: routeConfig.requisition.path,
        element: <Requisition />,
      },
      {
        path: routeConfig.regions.path,
        element: <Regions />,
      },
      {
        path: routeConfig.suppliers.path,
        element: <Suppliers />,
      },
      {
        path: routeConfig.notifications.path,
        element: <Notifications />,
      },
      {
        path: routeConfig.settings.path,
        element: <Settings />,
      },
      {
        path: routeConfig.purchase.path,
        element: <PurchaseOrder />,
      },
      {
        path: routeConfig.transactions.path,
        element: <Transactions />,
      },
    ],
  },
];

export default MainRoutes;
